import { useNavigate } from "react-router-dom";
import VideoPreview from "../../../assets/image/video.png";
import { Container } from "react-bootstrap";

function CTA() {
  const navigate = useNavigate();

  return (
    <Container className="py-5">
      <div className="row align-items-center mt-4 p-3 bg-light rounded shadow-sm">
        <div className="col-md-6 text-center">
          <img
            src={VideoPreview}
            alt="Video preview"
            className="img-fluid rounded-4"
            style={{ borderRadius: "2.5rem" }}
          />
        </div>

        <div className="col-md-6 text-center ps-md-5">
          <div className="text-center text-md-start">
            <p
              className="fw-bold"
              style={{ color: "#dc2626", fontSize: "18px" }}
            >
              SAVE MORE TIME
            </p>
            <h2 className="fw-bold" style={{ fontSize: "36px", color: "#000" }}>
              And Boost Productivity
            </h2>

            <p
              className="d-flex flex-column align-items-center text-md-start"
              style={{ color: "#4a5568", fontSize: "16px" }}
            >
              Your employees can bring any success into your business, so we
              need to take care of them.
            </p>

            <button
              className="custom-button mt-2"
              onClick={() => navigate("/signin")}
            >
              Get Started
            </button>
          </div>
        </div>
      </div>
    </Container>
  );
}

export default CTA;
